"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = exports.SmartSwiper = exports.swiperAria = exports.SlideTypeEnum = exports.StyledModalImageSwiper = exports.StyledImageSwiper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUsestateref = _interopRequireDefault(require("react-usestateref"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _ZoomInOutlined = _interopRequireDefault(require("@material-ui/icons/ZoomInOutlined"));
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _react2 = require("swiper/react");
require("swiper/swiper-bundle.min.css");
var _styled = _interopRequireDefault(require("@material-ui/core/styles/styled"));
var _panzoom = _interopRequireDefault(require("@panzoom/panzoom"));
var _useWindow5 = _interopRequireDefault(require("../hooks/useWindow"));
var _styles = require("../swiper/styles");
var _Zoom = _interopRequireDefault(require("../swiper/assets/Zoom.svg"));
var _Slides = require("./Slides");
var _HTMLVideoPlay = require("./HTMLVideoPlay");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var PRODUCT_INTERACTION_EVENT = 'product_interaction';
_swiper.default.use([_swiper.Navigation, _swiper.Pagination, _swiper.Scrollbar, _swiper.A11y, _swiper.Thumbs, _swiper.Keyboard, _swiper.Mousewheel, _swiper.Zoom, _swiper.Lazy]);
var RefSwiper = _react2.Swiper;
var StyledImageSwiper = (0, _styled.default)(_styles.StyledSwiper)(function (_ref) {
  var theme = _ref.theme;
  return {
    height: 'calc(100% - 100px)',
    '& .desktop-only': _defineProperty({
      display: 'block'
    }, theme.breakpoints.down('md'), {
      display: 'none'
    }),
    '& .mobile-only': _defineProperty({
      display: 'none'
    }, theme.breakpoints.down('md'), {
      display: 'block'
    })
  };
});
exports.StyledImageSwiper = StyledImageSwiper;
var StyledModalImageSwiper = (0, _styled.default)(_styles.StyledSwiper)(function (_ref2) {
  var _swiperButtonPre, _swiperButtonNex;
  var zoomed = _ref2.zoomed,
    theme = _ref2.theme;
  return {
    height: 'calc(100% - 200px)',
    '& .swiper-slide': {
      display: zoomed ? 'block' : 'flex',
      justifyContent: 'center',
      overflow: 'hidden'
    },
    '& .swiper-container': {
      margin: '0 auto',
      '& .swiper-button-prev': (_swiperButtonPre = {}, _defineProperty(_swiperButtonPre, theme.breakpoints.down('md'), {
        display: 'inherit'
      }), _defineProperty(_swiperButtonPre, '&::after', {
        display: 'none'
      }), _swiperButtonPre),
      '& .swiper-button-next': (_swiperButtonNex = {}, _defineProperty(_swiperButtonNex, theme.breakpoints.down('md'), {
        display: 'inherit'
      }), _defineProperty(_swiperButtonNex, '&::after', {
        display: 'none'
      }), _swiperButtonNex)
    }
  };
});
exports.StyledModalImageSwiper = StyledModalImageSwiper;
var breakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 1,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 1,
    spaceBetween: 10
  }
};
var thumbBreakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 4,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 10,
    spaceBetween: 10
  }
}; // internal slider implementation which we do not expose to users

var SlideTypeEnum = {
  image: 'image',
  youtube: 'youtube',
  htmlvideo: 'htmlvideo'
};
exports.SlideTypeEnum = SlideTypeEnum;
var toSlides = function toSlides(child, index) {
  if (! /*#__PURE__*/_react.default.isValidElement(child)) {
    return null;
  }
  var _child$props = child.props,
    type = _child$props.type,
    url = _child$props.url,
    thumbnail = _child$props.thumbnail,
    thumbnailsProps = _child$props.thumbnailsProps,
    originalSrc = _child$props.originalSrc,
    props = _objectWithoutProperties(_child$props, ["type", "url", "thumbnail", "thumbnailsProps", "originalSrc"]);
  var key = child.key || url || index;
  return {
    type: SlideTypeEnum[type] || SlideTypeEnum.image,
    key: key,
    url: url,
    originalSrc: originalSrc,
    thumbnail: thumbnail || url,
    props: props,
    // set alt from main image to thumbnail
    thumbnailsProps: _objectSpread({
      alt: props.alt
    }, thumbnailsProps)
  };
}; // parse slides definition either from array or from children;
// handles if images are broken

var useSlidesFromChildren = function useSlidesFromChildren(_ref3) {
  var _React$Children$map;
  var children = _ref3.children;
  var _useState = (0, _react.useState)((_React$Children$map = _react.default.Children.map(children, toSlides)) !== null && _React$Children$map !== void 0 ? _React$Children$map : []),
    _useState2 = _slicedToArray(_useState, 2),
    slides = _useState2[0],
    setSlides = _useState2[1];
  var hasThumbnails = (0, _react.useMemo)(function () {
    return slides.some(function (_ref4) {
      var thumbnail = _ref4.thumbnail,
        type = _ref4.type;
      return thumbnail || type === SlideTypeEnum.youtube;
    });
  }, [slides]);
  var loadedImages = (0, _react.useRef)({});
  var onImageError = function onImageError(index) {
    // show image failed alt text if image fails to load
    setSlides([].concat(_toConsumableArray(slides.slice(0, index)), [_objectSpread(_objectSpread({}, slides[index]), {}, {
      imageError: true
    })], _toConsumableArray(slides.slice(index + 1))));
  };
  var onImageLoad = function onImageLoad(url) {
    // prevents images from being loaded more than once
    Object.defineProperty(loadedImages.current, url, {
      value: true
    });
  }; // maps from Children to Slides

  (0, _react.useLayoutEffect)(function () {
    setSlides(_react.default.Children.map(children, toSlides));
  }, [children]);
  return {
    slides: slides,
    hasThumbnails: hasThumbnails,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    loadedImages: loadedImages
  };
};
function useSmartSwiperData(props) {
  var _useState3 = (0, _react.useState)(function () {
      return function () {};
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    zoomToggle = _useState4[0],
    setZoomToggle = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    mainSwiper = _useState6[0],
    setMainSwiper = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    thumbsSwiper = _useState8[0],
    setThumbsSwiper = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    hasZoom = _useState10[0],
    setHasZoom = _useState10[1]; // we have to override this props otherwise component will be broken

  var defaultProps = {
    a11y: {
      enable: true
    },
    direction: 'horizontal',
    freeMode: false,
    initialSlide: 0,
    keyboard: true,
    loop: false,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    mousewheel: false,
    noSwiping: false,
    breakpoints: breakpoints,
    centeredSlides: true,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    onSwiper: setMainSwiper,
    onAfterInit: function onAfterInit(swiper) {
      return setZoomToggle(function () {
        return swiper.zoom.toggle;
      });
    },
    // preloadImages: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 150,
    tag: 'section',
    thumbs: {
      swiper: thumbsSwiper
    },
    wrapperTag: 'ul',
    zoom: {
      toggle: false
    },
    simulateTouch: false,
    allowTouchMove: false
  };
  var defaultThumbProps = {
    breakpoints: thumbBreakpoints,
    tag: 'section',
    wrapperTag: 'ul',
    onSwiper: setThumbsSwiper,
    slidesPerView: 10,
    slidesPerGroup: 1,
    loopFillGroupWithBlank: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    scrollbar: {
      draggable: true
    },
    // preloadImages: true,
    speed: 150
  };
  var mergedProps = _objectSpread(_objectSpread({}, defaultProps), props);
  mergedProps.zoom = hasZoom ? mergedProps.zoom : null;
  return {
    thumbProps: defaultThumbProps,
    sliderProps: mergedProps,
    hasZoom: !!mergedProps.zoom,
    mainSwiper: mainSwiper,
    setHasZoom: setHasZoom,
    zoomToggle: zoomToggle
  };
}
var swiperAria = {
  prevButton: 'Previous slide',
  nextButton: 'Next slide',
  swiperThumbnailsLabelRoot: 'swiper thumbnails for youtube and images',
  swiperLabelRoot: 'swiper for youtube and images',
  thumbnailAlt: function thumbnailAlt(i) {
    return "slide thumbnail ".concat(i + 1);
  },
  slide: function slide(i) {
    return "slide image ".concat(i + 1);
  }
};
exports.swiperAria = swiperAria;
var swiperTestIds = {
  prevButton: 'swiper/prevButton',
  nextButton: 'swiper/nextButton',
  zoom: 'swiper/zoom',
  modalZoomButton: 'modalSwiper/modalZoomButton',
  modalPrevButton: 'swiper/prevButton',
  modalNextButton: 'swiper/nextButton'
};
var SmartSwiper = function SmartSwiper(_ref5) {
  var children = _ref5.children,
    onSetModalOpen = _ref5.onSetModalOpen,
    other = _objectWithoutProperties(_ref5, ["children", "onSetModalOpen"]);
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    currentSlideIndex = _useState12[0],
    setCurrentSlideIndex = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    modalOpen = _useState14[0],
    setModalOpen = _useState14[1];
  var _useSlidesFromChildre = useSlidesFromChildren({
      children: children
    }),
    slides = _useSlidesFromChildre.slides,
    hasThumbnails = _useSlidesFromChildre.hasThumbnails,
    onImageError = _useSlidesFromChildre.onImageError,
    onImageLoad = _useSlidesFromChildre.onImageLoad,
    loadedImages = _useSlidesFromChildre.loadedImages;
  var _useWindow = (0, _useWindow5.default)(),
    pushToDataLayer = _useWindow.pushToDataLayer;
  var swiperRef = (0, _react.useRef)(null);
  var isMobile = (0, _useMediaQuery.default)(function (theme) {
    return theme.breakpoints.down('md');
  });
  var isYoutube = function isYoutube(slide) {
    return slide.type === SlideTypeEnum.youtube;
  };
  var isHTMLVideo = function isHTMLVideo(slide) {
    return slide.type === SlideTypeEnum.htmlvideo;
  };
  var handleZoomClick = function handleZoomClick() {
    setModalOpen(true);
  };
  var sortSlides = function sortSlides(slideList) {
    slideList.forEach(function (_ref6, index) {
      var url = _ref6.url,
        type = _ref6.type;
      if (type !== SlideTypeEnum.image) {
        // Move video to third index, or end if less than 3 elements
        if (slideList.length >= 3) {
          var vid = slideList.splice(index, 1)[0];
          slideList.splice(2, 0, vid);
        } else {
          slideList.push(slideList.splice(index, 1)[0]);
        }
      }
    });
    return slideList;
  }; // Sort slides to place video in 3rd index

  var sortedSlides = sortSlides(slides); // Effect hook for Product Interactions - ZOOM

  (0, _react.useEffect)(function () {
    if (modalOpen != null) {
      if (typeof onSetModalOpen === 'function') onSetModalOpen(modalOpen);
      pushToDataLayer({
        event: PRODUCT_INTERACTION_EVENT,
        data: {
          type: 'zoom',
          selection: modalOpen ? 'open' : 'close',
          index: currentSlideIndex
        }
      });
    }
  }, [modalOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !modalOpen && /*#__PURE__*/_react.default.createElement(MainSwiper, {
    isMobile: isMobile,
    swiperRef: swiperRef,
    handleZoomClick: handleZoomClick,
    slides: sortedSlides,
    hasThumbnails: hasThumbnails,
    isYoutube: isYoutube,
    isHTMLVideo: isHTMLVideo,
    currentSlideIndex: currentSlideIndex,
    setCurrentSlideIndex: setCurrentSlideIndex,
    other: other,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    loadedImages: loadedImages
  }), modalOpen && /*#__PURE__*/_react.default.createElement(SwiperModal, {
    isMobile: isMobile,
    other: other,
    swiperRef: swiperRef,
    slides: sortedSlides,
    hasThumbnails: hasThumbnails,
    isYoutube: isYoutube,
    isHTMLVideo: isHTMLVideo,
    currentSlideIndex: currentSlideIndex,
    setCurrentSlideIndex: setCurrentSlideIndex,
    modalOpen: modalOpen,
    setModalOpen: setModalOpen,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    loadedImages: loadedImages
  }));
};
exports.SmartSwiper = SmartSwiper;
var MainSwiper = function MainSwiper(_ref7) {
  var isMobile = _ref7.isMobile,
    other = _ref7.other,
    swiperRef = _ref7.swiperRef,
    handleZoomClick = _ref7.handleZoomClick,
    slides = _ref7.slides,
    hasThumbnails = _ref7.hasThumbnails,
    isYoutube = _ref7.isYoutube,
    isHTMLVideo = _ref7.isHTMLVideo,
    setCurrentSlideIndex = _ref7.setCurrentSlideIndex,
    currentSlideIndex = _ref7.currentSlideIndex,
    onImageLoad = _ref7.onImageLoad,
    onImageError = _ref7.onImageError,
    loadedImages = _ref7.loadedImages;
  var _useSmartSwiperData = useSmartSwiperData(other),
    mainSwiper = _useSmartSwiperData.mainSwiper,
    sliderProps = _useSmartSwiperData.sliderProps,
    thumbProps = _useSmartSwiperData.thumbProps;
  var _useWindow2 = (0, _useWindow5.default)(),
    pushToDataLayer = _useWindow2.pushToDataLayer;
  var _useState15 = (0, _react.useState)(true),
    _useState16 = _slicedToArray(_useState15, 2),
    showZoom = _useState16[0],
    setShowZoom = _useState16[1];
  var handleNavigationClick = function handleNavigationClick(direction) {
    pushToDataLayer({
      event: PRODUCT_INTERACTION_EVENT,
      data: {
        type: 'slide',
        selection: direction,
        index: currentSlideIndex
      }
    });
  };
  (0, _react.useEffect)(function () {
    var noZoomIndex;
    slides.forEach(function (slide, index) {
      if (slide.type !== SlideTypeEnum.image) {
        noZoomIndex = index;
      }
    });
    if (currentSlideIndex === noZoomIndex) {
      setShowZoom(false);
    } else {
      setShowZoom(true);
    }
  }, [currentSlideIndex]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledImageSwiper, {
    "aria-label": swiperAria.swiperLabelRoot
  }, /*#__PURE__*/_react.default.createElement(RefSwiper, _extends({}, sliderProps, {
    ref: swiperRef,
    initialSlide: currentSlideIndex,
    onSlideChange: function onSlideChange(s) {
      if (typeof sliderProps.onSlideChange === 'function') sliderProps.onSlideChange(s, slides);
      setCurrentSlideIndex(s.activeIndex);
    },
    simulateTouch: true,
    allowTouchMove: true
  }), /*#__PURE__*/_react.default.createElement(SlideNavigators, {
    testIdNext: swiperTestIds.nextButton,
    testIdPrev: swiperTestIds.prevButton,
    handleLeftClick: function handleLeftClick() {
      return handleNavigationClick('left');
    },
    handleRightClick: function handleRightClick() {
      return handleNavigationClick('right');
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": swiperTestIds.zoom,
    onClick: function onClick() {
      return handleZoomClick();
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === '' && handleZoomClick();
    },
    className: "zoom-icon",
    type: "button",
    style: {
      display: showZoom ? 'block' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "desktop-only",
    alt: "Zoom icon",
    src: _Zoom.default
  }), /*#__PURE__*/_react.default.createElement(_ZoomInOutlined.default, {
    className: "mobile-only",
    alt: "Zoom icon"
  })), slides.map(function (slide, i) {
    if (slide.type === SlideTypeEnum.youtube || slide.type === SlideTypeEnum.htmlvideo) {
      return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
        "aria-label": swiperAria.slide(i),
        key: slide.key,
        tag: "li",
        zoom: true
      }, function (isActiveProps) {
        if (slide.type === SlideTypeEnum.youtube) {
          return /*#__PURE__*/_react.default.createElement(_Slides.YoutubeSlide, _extends({
            setZoom: function setZoom() {},
            isActive: isActiveProps.isActive,
            url: slide.url
          }, slide.props));
        }
        return /*#__PURE__*/_react.default.createElement(_Slides.VideoSlide, _extends({
          title: swiperAria.thumbnailAlt(i),
          setZoom: function setZoom() {},
          isActive: isActiveProps.isActive,
          url: slide.url
        }, slide.props));
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      "aria-label": swiperAria.slide(i),
      key: slide.key,
      tag: "li",
      zoom: true
    }, /*#__PURE__*/_react.default.createElement(_Slides.ImageSlide, _extends({
      index: i,
      style: {
        cursor: isMobile ? 'zoom-in' : 'auto'
      },
      onClick: function onClick() {
        return isMobile ? handleZoomClick() : {};
      },
      alt: slide.imageError ? "".concat(swiperAria.slide(i), " - Failed to load image") : swiperAria.slide(i)
    }, slide.props, {
      url: slide.url,
      onError: function onError() {
        return onImageError(i);
      },
      onLoad: function onLoad() {
        return !loadedImages.current[slide.url] && onImageLoad(slide.url);
      }
    })), i !== 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "swiper-lazy-preloader"
    }));
  }))), /*#__PURE__*/_react.default.createElement(BottomSwiper, {
    swiperRef: swiperRef,
    hasThumbnails: hasThumbnails,
    currentSlideIndex: currentSlideIndex,
    setCurrentSlideIndex: setCurrentSlideIndex,
    thumbProps: thumbProps,
    slides: slides,
    isYoutube: isYoutube,
    isHTMLVideo: isHTMLVideo
  }), /*#__PURE__*/_react.default.createElement(SwiperBullets, {
    mainSwiper: mainSwiper,
    slides: slides,
    currentSlideIndex: currentSlideIndex
  }));
};
var SwiperModal = function SwiperModal(_ref8) {
  var other = _ref8.other,
    swiperRef = _ref8.swiperRef,
    slides = _ref8.slides,
    hasThumbnails = _ref8.hasThumbnails,
    isYoutube = _ref8.isYoutube,
    isHTMLVideo = _ref8.isHTMLVideo,
    setCurrentSlideIndex = _ref8.setCurrentSlideIndex,
    currentSlideIndex = _ref8.currentSlideIndex,
    modalOpen = _ref8.modalOpen,
    setModalOpen = _ref8.setModalOpen,
    isMobile = _ref8.isMobile,
    onImageLoad = _ref8.onImageLoad,
    onImageError = _ref8.onImageError,
    loadedImages = _ref8.loadedImages;
  var _useSmartSwiperData2 = useSmartSwiperData(other),
    mainSwiper = _useSmartSwiperData2.mainSwiper,
    sliderProps = _useSmartSwiperData2.sliderProps,
    thumbProps = _useSmartSwiperData2.thumbProps,
    setHasZoom = _useSmartSwiperData2.setHasZoom;
  var _useStateRef = (0, _reactUsestateref.default)(false),
    _useStateRef2 = _slicedToArray(_useStateRef, 3),
    zoomed = _useStateRef2[0],
    setZoomed = _useStateRef2[1],
    zoomedRef = _useStateRef2[2];
  var _useStateRef3 = (0, _reactUsestateref.default)(),
    _useStateRef4 = _slicedToArray(_useStateRef3, 3),
    _ = _useStateRef4[0],
    setPanZoomed = _useStateRef4[1],
    panZoomedRef = _useStateRef4[2];
  var _useWindow3 = (0, _useWindow5.default)(),
    pushToDataLayer = _useWindow3.pushToDataLayer;
  var currentSlide = slides === null || slides === void 0 ? void 0 : slides.find(function (s, i) {
    return i === currentSlideIndex;
  });
  var zoomButtonVisible = !isMobile && !isYoutube(currentSlide || {}) && !isHTMLVideo(currentSlide || {});
  var handleModalZoomButton = function handleModalZoomButton() {
    return setZoomed(!zoomed);
  };
  (0, _react.useEffect)(function () {
    if (isMobile) setZoomed(true);
  }, [currentSlideIndex, isMobile]);
  (0, _react.useEffect)(function () {
    pushToDataLayer({
      event: PRODUCT_INTERACTION_EVENT,
      data: {
        type: 'zoom',
        selection: zoomed ? 'in' : 'out',
        index: currentSlideIndex
      }
    });
  }, [zoomed]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: modalOpen,
    onClose: function onClose() {
      return setModalOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledModalBody, null, /*#__PURE__*/_react.default.createElement(_styles.StyledCloseIcon, {
    onClick: function onClick() {
      return setModalOpen(false);
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === '' && setModalOpen(false);
    }
  }), zoomButtonVisible && /*#__PURE__*/_react.default.createElement(_styles.StyledZoomButton, {
    onClick: handleModalZoomButton,
    "data-testid": swiperTestIds.modalZoomButton,
    role: "button",
    type: "button",
    "tab-index": "0",
    "aria-pressed": zoomed,
    "aria-label": "Zoom"
  }, zoomed ? 'ZOOM OUT' : 'ZOOM IN'), /*#__PURE__*/_react.default.createElement(StyledModalImageSwiper, {
    zoomed: zoomed,
    "aria-label": swiperAria.swiperLabelRoot
  }, /*#__PURE__*/_react.default.createElement(RefSwiper, _extends({}, sliderProps, {
    ref: swiperRef,
    initialSlide: currentSlideIndex,
    onSlideChange: function onSlideChange(s) {
      setZoomed(false);
      setCurrentSlideIndex(s.activeIndex);
    }
  }), /*#__PURE__*/_react.default.createElement(SlideNavigators, {
    testIdNext: swiperTestIds.modalNextButton,
    testIdPrev: swiperTestIds.modalPrevButton
  }), slides.map(function (slide, i) {
    if (slide.type === SlideTypeEnum.youtube || slide.type === SlideTypeEnum.htmlvideo) {
      return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
        "aria-label": swiperAria.slide(i),
        key: slide.key,
        tag: "li",
        zoom: true
      }, function (isActiveProps) {
        if (slide.type === SlideTypeEnum.youtube) {
          return /*#__PURE__*/_react.default.createElement(_Slides.YoutubeSlide, _extends({
            setZoom: function setZoom() {},
            isActive: isActiveProps.isActive,
            url: slide.url
          }, slide.props));
        }
        return /*#__PURE__*/_react.default.createElement(_Slides.VideoSlide, _extends({
          title: swiperAria.thumbnailAlt(i),
          setZoom: function setZoom() {},
          isActive: isActiveProps.isActive,
          url: slide.url
        }, slide.props));
      });
    }
    var imageSlideRef = (0, _react.useRef)(null);
    /* allows us to zoom in and pan the image with ease (https://github.com/timmywil/panzoom) */

    (0, _react.useEffect)(function () {
      /* if the image is not zoomed in, do nothing */
      if (zoomed) {
        // eslint-disable-next-line func-names
        var wheelZoomHandler = function wheelZoomHandler(e, panzoom) {
          /* if the user is zoomed in, enable zoom with the mouse wheel */
          if (zoomedRef.current) {
            panzoom.zoomWithWheel(e);
          }
        };
        /* get the zoomed in image */

        var elem = imageSlideRef.current;
        /* instantiate the zoom plugin, containing the zoomed in image */

        var plugin = (0, _panzoom.default)(elem, {
          maxScale: 4,
          minScale: 1,
          excludeClass: 'panzoom-exclude',
          contain: 'outside'
        });
        setPanZoomed(_objectSpread(_objectSpread({}, panZoomedRef.current), {}, _defineProperty({}, slide.key, plugin)));
        var pz = panZoomedRef.current[slide.key];
        /* are we zoomed in? */

        if (zoomedRef.current && pz) {
          /* attach a mouse wheel event listener to the image after zoomed in */
          elem.parentElement.addEventListener('wheel', function (e) {
            return wheelZoomHandler(e, pz);
          });
          /* are we on a mobile device? */

          if (!isMobile) {
            /* zoom to "1.5" for desktop */
            pz.zoom(1.5, {
              animate: true,
              duration: 300
            });
          }
        }
      } else if (!zoomed) {
        if (panZoomedRef.current && panZoomedRef.current[slide.key]) {
          var _pz = panZoomedRef.current[slide.key];
          /* center the image and zoom out, then destroy the event listeners and reset the mouse-over styles */

          _pz.pan(0, 0);
          _pz.zoom(1, {
            animate: true,
            duration: 300
          });
          _pz.resetStyle();
          _pz.destroy();
        }
      }
    }, [zoomed]);
    var display = isMobile ? 'flex' : 'block';
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      "aria-label": swiperAria.slide(i),
      key: slide.key,
      tag: "li"
      /* we use inline styles here because a styled component did not work */,

      style: {
        display: "".concat(display)
      }
    }, /*#__PURE__*/_react.default.createElement(_styles.StyledImageSlide, _extends({
      ref: imageSlideRef,
      className: i === 0 ? '' : 'swiper-lazy',
      alt: swiperAria.slide(i)
    }, slide.props, {
      onClick: null,
      id: slide.key,
      url: slide.originalSrc,
      index: i,
      onError: function onError() {
        return onImageError(i);
      },
      onLoad: function onLoad() {
        return !loadedImages.current[slide.url] && onImageLoad(slide.url);
      }
      /* important for using the mouse to pan around the image */,

      draggable: "false"
    })), i !== 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "swiper-lazy-preloader"
    }));
  }))), /*#__PURE__*/_react.default.createElement(BottomSwiper, {
    hasThumbnails: hasThumbnails,
    currentSlideIndex: currentSlideIndex,
    thumbProps: thumbProps,
    slides: slides,
    isYoutube: isYoutube,
    isHTMLVideo: isHTMLVideo
  }), /*#__PURE__*/_react.default.createElement(SwiperBullets, {
    mainSwiper: mainSwiper,
    slides: slides,
    currentSlideIndex: currentSlideIndex
  }))));
};
var SlideNavigators = function SlideNavigators(_ref9) {
  var testIdNext = _ref9.testIdNext,
    testIdPrev = _ref9.testIdPrev,
    handleLeftClick = _ref9.handleLeftClick,
    handleRightClick = _ref9.handleRightClick;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleLeftClick,
    "data-testid": testIdNext,
    "aria-label": swiperAria.prevButton,
    className: "swiper-button-prev",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, {
    style: {
      fontSize: 40
    }
  })), /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleRightClick,
    "data-testid": testIdPrev,
    "aria-label": swiperAria.nextButton,
    className: "swiper-button-next",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, {
    style: {
      fontSize: 40
    }
  })));
};
var BottomSwiper = function BottomSwiper(_ref10) {
  var swiperRef = _ref10.swiperRef,
    hasThumbnails = _ref10.hasThumbnails,
    currentSlideIndex = _ref10.currentSlideIndex,
    setCurrentSlideIndex = _ref10.setCurrentSlideIndex,
    thumbProps = _ref10.thumbProps,
    slides = _ref10.slides,
    isYoutube = _ref10.isYoutube,
    isHTMLVideo = _ref10.isHTMLVideo;
  var _useWindow4 = (0, _useWindow5.default)(),
    pushToDataLayer = _useWindow4.pushToDataLayer;
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    thumbnail = _useState18[0],
    setThumbnail = _useState18[1];
  var handleBottomSliderClick = function handleBottomSliderClick() {
    pushToDataLayer({
      event: PRODUCT_INTERACTION_EVENT,
      data: {
        type: 'select',
        index: currentSlideIndex
      }
    });
  };
  var handleKeyDown = function handleKeyDown(event, index) {
    if (event.key === 'Enter') {
      var _swiperRef$current, _swiperRef$current$sw;
      swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : (_swiperRef$current$sw = _swiperRef$current.swiper) === null || _swiperRef$current$sw === void 0 ? void 0 : _swiperRef$current$sw.slideTo(index);
      setCurrentSlideIndex(index);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasThumbnails && /*#__PURE__*/_react.default.createElement(_styles.StyledThumbs, {
    "aria-label": swiperAria.swiperThumbnailsLabelRoot
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({}, thumbProps, {
    initialSlide: currentSlideIndex,
    swiperRef: swiperRef
  }), slides.map(function (slide, i) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: slide.key,
      tag: "li"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "slide-padding",
      "aria-label": swiperAria.thumbnailAlt(i),
      onClick: function onClick() {
        return handleBottomSliderClick();
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, i);
      }
    }, (isYoutube(slide) || isHTMLVideo(slide)) && /*#__PURE__*/_react.default.createElement(_HTMLVideoPlay.HTMLVideoPlayButton, null), /*#__PURE__*/_react.default.createElement("img", _extends({
      alt: swiperAria.thumbnailAlt(i)
    }, slide.thumbnailsProps, {
      src: slide.thumbnail
    }))));
  }))));
};
var SwiperBullets = function SwiperBullets(_ref11) {
  var mainSwiper = _ref11.mainSwiper,
    slides = _ref11.slides,
    currentSlideIndex = _ref11.currentSlideIndex;
  var slideTo = function slideTo(index) {
    mainSwiper.slideTo(index);
  };
  var slideNext = function slideNext() {
    return mainSwiper.slideNext();
  };
  var handleMiddleClick = function handleMiddleClick() {
    switch (currentSlideIndex) {
      case 0:
      case 1:
      case slides.length - 1:
      case slides.length - 2:
      case slides.length - 3:
        slideTo(2);
        break;
      default:
        slideNext();
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_styles.StyledPagination, null, slides.length > 5 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(currentSlideIndex === 0 ? ' slide-pagination-bullet-active' : '').concat(slides[0].type === 'htmlvideo' ? ' arrow' : ''),
    onClick: function onClick() {
      return slideTo(0);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to 1")), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(currentSlideIndex === 1 ? ' slide-pagination-bullet-active' : '').concat(slides[1].type === 'htmlvideo' ? ' arrow' : ''),
    onClick: function onClick() {
      return slideTo(1);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to 2")), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(currentSlideIndex > 1 && currentSlideIndex < slides.length - 2 ? ' slide-pagination-bullet-active' : '').concat(slides[2].type === 'htmlvideo' ? ' arrow' : ''),
    onClick: handleMiddleClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(currentSlideIndex === slides.length - 3 ? '3' : 'next'))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(currentSlideIndex === slides.length - 2 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(slides.length - 2);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(slides.length - 1))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(currentSlideIndex === slides.length - 1 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(slides.length - 1);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(slides.length)))) : slides.map(function (_slide, index) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      key: "slide-pagination-".concat(Math.random().toString()),
      className: "slide-pagination-bullet".concat(currentSlideIndex === index ? ' slide-pagination-bullet-active' : '').concat(_slide.type === 'htmlvideo' ? ' arrow' : ''),
      onClick: function onClick() {
        return slideTo(index);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Slide to ".concat(index + 1)));
  }));
}; // we use this component to workaround issue with swiper which wants to have SwiperSlide as it's primary children
// we want to have nice jsx api but at the same time have strict api, so we are doing same thing as Swiper.js
// and implement our own Slide representation which is used only for passing props to component
// eslint-disable-next-line no-unused-vars

var Slide = function Slide() {
  throw new Error('should not be rendered');
}; // We use compound components here, so we won't have name slashes since slide is quite common name

exports.Slide = Slide;
SmartSwiper.Slide = Slide;